import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Domains from './pages/Domains';
import Orders from './pages/Orders';
import Sources from './pages/Sources';
import Users from './pages/Users';
import Managers from './pages/Managers';
import EppCategories from './pages/EppCategories';
import EppAccounts from './pages/EppAccounts';
import EppLogs from './pages/EppLogs';
import EppTools from './pages/EppTools';
import Payments from './pages/Payments';
import Invoices from './pages/Invoices';
import AuditLogs from './pages/AuditLogs';
import News from './pages/News';
import Profile from './pages/Profile';
import Schedulers from './pages/Schedulers';
import Released from './pages/Released';
import DataSources from './pages/DataSources';

function App() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to="/" />} />

      <Route element={<PrivateRoute />}>
        <Route element={<Layout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/domains" element={<Domains />} />
          <Route path="/released" element={<Released />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/sources" element={<Sources />} />
          <Route path="/data-sources" element={<DataSources />} />
          <Route path="/users" element={<Users />} />
          <Route path="/managers" element={<Managers />} />
          <Route path="/epp-categories" element={<EppCategories />} />
          <Route path="/epp-accounts" element={<EppAccounts />} />
          <Route path="/epp-logs" element={<EppLogs />} />
          <Route path="/epp-tools" element={<EppTools />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/invoices" element={<Invoices />} />
          <Route path="/audit-logs" element={<AuditLogs />} />
          <Route path="/schedulers" element={<Schedulers />} />
          <Route path="/news" element={<News />} />
          <Route path="/profile" element={<Profile />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;